import { partitionArray } from '@angular/compiler/src/util';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SecurityResultStatus } from 'src/app/clients/system-api/SystemApiClient';
import { confirmPasswordValidator } from 'src/app/services/confirm-password.validator';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss']
})
export class VerificationCodeComponent implements OnInit {
  @ViewChild('changePasswordNgForm') changePasswordNgForm!: NgForm;
  changePasswordForm!: FormGroup;

  verifyCode!: string;
  verificationCodeId!: number | undefined;
  newPassword!: string | undefined;
  confirmPassword!: string | undefined;
  email!: string;
  code!: string;
  TransLang: string[] = [];

  constructor(public userService: UserService,
              private _formBuilder: FormBuilder,
              private router: Router,
              private _snackBarService : SnackBarService,
              private route: ActivatedRoute,
              private translate: TranslateService,
  ) { 
    translate.setDefaultLang('mk');
    translate.addLangs(['mk', 'al']);
  }

  ngOnInit(): void {
    this.route.params.subscribe(parameter => {
      this.verificationCodeId = parameter['id'];
      this.email = parameter['email'];
      this.verifyCode = parameter['code'];
    });

    this.getTransLanguage();

    this.changePasswordForm = this._formBuilder.group(
      {
        verifyCode: ['', Validators.required],
        newPassword: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      },
      {
        validator: confirmPasswordValidator("newPassword", "confirmPassword")
      }
    );
  }

  getTransLanguage() {
    this.TransLang = [...this.translate.getLangs()];
  }

  get f(){
    return this.changePasswordForm.controls;
  }

  resendCode(){
    this.userService.generateResetPasswordCode(this.email).subscribe((data) =>{
      this._snackBarService.callSnackBar(data.status, "EmailVerificationCode");
    }, error => {
      this._snackBarService.callSnackBar(error);
    });
  }

  onSubmit() {
    this.userService.resetPasswordWithCode(this.verificationCodeId, this.verifyCode, this.newPassword).subscribe((data) => {
      this._snackBarService.callSnackBar(data, "Change Password");
      if (data == SecurityResultStatus.Success) {
        this.router.navigate(["/login"]);
      }
    }, error => {
      this._snackBarService.callSnackBar(error);
    });
  }
}
